export {
  Switch,
  switchVariants,
  switchThumbVariants,
  type SwitchProps,
} from "./components/Switch/Switch"
